import { render, staticRenderFns } from "./ShopifySendBtn.vue?vue&type=template&id=36ae17ee&scoped=true&"
import script from "./ShopifySendBtn.vue?vue&type=script&lang=ts&"
export * from "./ShopifySendBtn.vue?vue&type=script&lang=ts&"
import style0 from "./ShopifySendBtn.vue?vue&type=style&index=0&id=36ae17ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae17ee",
  null
  
)

export default component.exports